export const VIEWING_WIDTH = 900;
